import { Helmet } from 'react-helmet-async';

import { UpdateUserPasswordForm } from '~/components/forms/UserPasswordForm';
import { UpdateUserProfileForm } from '~/components/forms/UserProfileForm';
import { useNavigate } from '~/components/utils/Navigation';

type IUpdateUserPageProps = {
  userId: string;
};

export const UpdateUserPage: React.FC<IUpdateUserPageProps> = (props) => {
  const { userId } = props;
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Me</title>
      </Helmet>

      <UpdateUserProfileForm
        userId={userId}
        onSuccess={() => navigate('/me/update')}
        cancelUrl="/apps"
      />
      <UpdateUserPasswordForm
        userId={userId}
        onSuccess={() => navigate('/me/update')}
        cancelUrl="/apps"
      />
    </>
  );
};
